import React from 'react';
import ServicesPage from '../../components/Services/ServicesPage';
import ServiceImg1 from '../../assets/images/services/services-1-1.jpg';
import ServiceImg2 from '../../assets/images/services/services-1-2.jpg';
import ServiceImg3 from '../../assets/images/services/services-1-3.jpg';
import ServiceImg4 from '../../assets/images/services/services-1-4.jpg';
import ServiceImg5 from '../../assets/images/services/services-1-5.jpg';
import ServiceImg6 from '../../assets/images/services/services-1-6.jpg';

const ServicesMain = () => {
    const servicesData = [
        {
          imgSrc: ServiceImg1,
          iconClass: 'icon-paint',
          title: 'Reliable Roofing Pros',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'reliable-roof-repair',
        },
        {
          imgSrc: ServiceImg2,
          iconClass: 'icon-paint',
          title: 'Superior Roofing Services',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'sure-guard-roofing-services',
        },
        {
          imgSrc: ServiceImg3,
          iconClass: 'icon-paint',
          title: 'Roof Service Involves',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'peak-performance-roofing',
        },
        {
          imgSrc: ServiceImg4,
          iconClass: 'icon-setting',
          title: 'Skyline Roofing',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'skyline-roofing-solutions',
        },
        {
          imgSrc: ServiceImg5,
          iconClass: 'icon-box-2',
          title: 'Roofing Solutions',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'top-notch-roofing-restoration',
        },
        {
          imgSrc: ServiceImg6,
          iconClass: 'icon-stairs',
          title: 'Peak Performance',
          description: 'Roof service involves the maintenance and repair of residential roofs.',
          link: 'peak-performance-roofing',
        },
      ];

    return (
        <React.Fragment>
            {/*Services Page Start*/}
            <ServicesPage services={servicesData} />
            {/*Services Page End*/}
        </React.Fragment>
    );
};

export default ServicesMain;
